export default "__VITE_ASSET__ChDQ2DJg__"